<div mat-dialog-content>
  <lemon-dialog-header>
    {{ 'lasku.muokkaus-estetty.ei-mahdollista' | translate | async }}
  </lemon-dialog-header>
  {{ 'lasku.muokkaus-estetty.katseltavaa-laskua-ei-voi-muokata' | translate | async }}
</div>
<div mat-dialog-actions>
  <button class="primarybutton" mat-button mat-dialog-close>{{ 'yleiset.ok' | translate | async }}</button>
</div>
